import { TOKEN_ADDRESS, TokenAddressChainValue } from '@silo/addresses';
import { ChainIdLegacy, ChecksumAddress, SupportedChainId, SupportedChainValue, isSupportedChainId } from '@silo/types';
import { option } from 'fp-ts';
import { constNull, pipe } from 'fp-ts/lib/function';

const unknownLogo = '/images/logos/unknown.png';

const usdcLogo = '/images/logos/USDC.png';
const wethLogo = '/images/logos/ETH-light.png';
const apeLogo = '/images/logos/APE.png';
const balLogo = '/images/logos/BAL.png';
const crvLogo = '/images/logos/CRV.png';
const crvUSDLogo = '/images/logos/crvUSD.png';
const cvxLogo = '/images/logos/CVX.png';
const fraxLogo = '/images/logos/FRAX.png';
const fxsLogo = '/images/logos/FXS.png';
const wbtcLogo = '/images/logos/WBTC.png';
const wstethLogo = '/images/logos/wstETH.png';
const cbethLogo = '/images/logos/cbETH.png';
const xaiLogo = '/images/logos/XAI.png';
const linkLogo = '/images/logos/LINK.png';
const auraLogo = '/images/logos/AURA.png';
const sushiLogo = '/images/logos/SUSHI.png';
const xsushiLogo = '/images/logos/xSUSHI.png';
const badgerLogo = '/images/logos/BADGER.png';
const usdtLogo = '/images/logos/USDT.png';
const enjLogo = '/images/logos/ENJ.png';
const paxgLogo = '/images/logos/PAXG.png';
const mimLogo = '/images/logos/MIM.png';
const ohmLogo = '/images/logos/OHM.png';
const wooLogo = '/images/logos/WOO.png';
const zrxLogo = '/images/logos/ZRX.png';
const shibLogo = '/images/logos/SHIB.png';
const gusdLogo = '/images/logos/GUSD.png';
const usdpLogo = '/images/logos/USDP.png';
const croLogo = '/images/logos/CRO.png';
const compLogo = '/images/logos/COMP.png';
const manaLogo = '/images/logos/MANA.png';
const gOhmLogo = '/images/logos/gOHM.png';
const gnoLogo = '/images/logos/GNO.png';
const lusdLogo = '/images/logos/LUSD.png';
const ensLogo = '/images/logos/ENS.png';
const imxLogo = '/images/logos/IMX.png';
const busdLogo = '/images/logos/BUSD.png';
const oneInchLogo = '/images/logos/1INCH.png';
const qntLogo = '/images/logos/QNT.png';
const tusdLogo = '/images/logos/TUSD.png';
const yfiLogo = '/images/logos/YFI.png';
const batLogo = '/images/logos/BAT.png';
const umaLogo = '/images/logos/UNA.png';
const susdLogo = '/images/logos/sUSD.png';
const jpegLogo = '/images/logos/JPEG.png';
const bntLogo = '/images/logos/BNT.png';
const ldoLogo = '/images/logos/LDO.png';
const usddLogo = '/images/logos/USDD.png';
const sEth2Logo = '/images/logos/SETH2.png';
const nftxLogo = '/images/logos/NFTX.png';
const daiLogo = '/images/logos/DAI.png';
const bitLogo = '/images/logos/BIT.png';
const spellLogo = '/images/logos/SPELL.png';
const farmLogo = '/images/logos/FARM.png';
const rplLogo = '/images/logos/RPL.png';
const lqtyLogo = '/images/logos/LQTY.png';
const oceanLogo = '/images/logos/OCEAN.png';
const alcxLogo = '/images/logos/ALCX.png';
const dydxLogo = '/images/logos/DYDX.png';
const sandLogo = '/images/logos/SAND.png';
const snxLogo = '/images/logos/SNX.png';
const uniLogo = '/images/logos/UNI.png';
const aaveLogo = '/images/logos/AAVE.png';
const raiLogo = '/images/logos/RAI.png';
const kp3rLogo = '/images/logos/KP3R.png';
const funLogo = '/images/logos/FUN.png';
const fttLogo = '/images/logos/FTT.png';
const perpLogo = '/images/logos/PERP.png';
const wNXMLogo = '/images/logos/WNXM.png';
const mkrLogo = '/images/logos/MKR.png';
const looksLogo = '/images/logos/LOOKS.png';
const agEurLogo = '/images/logos/AGEUR.png';
const rEthLogo = '/images/logos/RETH.png';
const pepeLogo = '/images/logos/PEPE.png';
const xdefiLogo = '/images/logos/XDEFI.png';
const ethStEthLogo = '/images/logos/ETH-stETH.png';
const fraxUsdcLogo = '/images/logos/FRAX-USDC.png';
const ethCbEthLogo = '/images/logos/ETH-cbETH.png';
const lusd3CrvLogo = '/images/logos/LUSD-3CRV.png';
const boxEthLogo = '/images/logos/BOX-ETH.png';
const uwuLogo = '/images/logos/UWU.png';
const weETHLogo = '/images/logos/weETH.png';
const ethXLogo = '/images/logos/ETHx.png';
const ptEzEthLogo = '/images/logos/PT-ezETH.png';
const sUSDeLogo = '/images/logos/sUSDe.png';
const ezEthLogo = '/images/logos/ezETH.png';
const PTrswETHLogo = '/images/logos/PTrswETH.png';
const rsEthLogo = '/images/logos/rsETH.png';
const PTrsETHLogo = '/images/logos/PTrsETH.png';
const PT_pufETH_logo = '/images/logos/PT-pufETH.png';
const PT_sUSDE_logo = '/images/logos/PT-sUSDE.png';
const pzETHLogo = '/images/logos/pzETH.png';
const amphrETHLogo = '/images/logos/amphrETH.png';
const rstETHLogo = '/images/logos/rstETH.png';
const re7LRTLogo = '/images/logos/re7LRT.png';

//arb
const gmdLogo = '/images/logos/GMD.png';
const usdsLogo = '/images/logos/USDs.png';
const gmxLogo = '/images/logos/GMX.png';
const umamiLogo = '/images/logos/UMAMI.png';
const dpxLogo = '/images/logos/DPX.png';
const magicLogo = '/images/logos/MAGIC.png';
const capLogo = '/images/logos/CAP.png';
const rDpxLogo = '/images/logos/rDPX.png';
const gnsLogo = '/images/logos/GNS.png';
const arbLogo = '/images/logos/ARB.png';
const premiaLogo = '/images/logos/PREMIA.png';
const jonesLogo = '/images/logos/JONES.png';
const siloLogo = '/images/logos/SILO.png';
const y2kLogo = '/images/logos/Y2K.png';
const joeLogo = '/images/logos/JOE.png';
const plsLogo = '/images/logos/PLS.png';
const grailLogo = '/images/logos/GRAIL.png';
const pendleLogo = '/images/logos/PENDLE.png';
const rdntLogo = '/images/logos/RDNT.png';
const winrLogo = '/images/logos/WINR.png';
const stEURLogo = '/images/logos/stEUR.png';
const PTeETHLogo = '/images/logos/PTeETH.png';
const tBtcLogo = '/images/logos/tBTC.png';
const graiLogo = '/images/logos/GRAI.png';
const WOETHLogo = '/images/logos/WOETH.png';
const PTUSDeLogo = '/images/logos/PTUSDe.png';
const uniETHLogo = '/images/logos/uniETH.png';
const ETHplusLogo = '/images/logos/ETHplus.png';
const PEASLogo = '/images/logos/PEAS.png';
const RAMLogo = '/images/logos/RAM.png';
const wUSDplusLogo = '/images/logos/wUSDplus.png';
const gUSDCLogo = '/images/logos/gUSDC.png';
const dlcBTCLogo = '/images/logos/dlcBTC.png';
const orderLogo = '/images/logos/ORDER.png';
const gmETHLogo = '/images/logos/gmETH.png';
const tangoLogo = '/images/logos/TANGO.png';

// optimism
const opLogo = '/images/logos/OP.png';
const veloLogo = '/images/logos/VELO.png';
const wldLogo = '/images/logos/WLD.png';
const sfrxEthLogo = '/images/logos/sfrxETH.png';
const uniBTCLogo = '/images/logos/uniBTC.png';
const wUSDMLogo = '/images/logos/wUSDM.png';
const mooBIFILogo = '/images/logos/mooBIFI.png';

// base
const degenLogo = '/images/logos/DEGEN.png';
const aeroLogo = '/images/logos/AERO.png';
const bsdEthLogo = '/images/logos/bsdETH.png';
const cbBTCLogo = '/images/logos/cbBTC.png';
const sUSDzLogo = '/images/logos/sUSDz.png';
const EURCLogo = '/images/logos/EURC.png';
const wSuperOETHbLogo = '/images/logos/wSuperOETHb.png';
const hyUSDLogo = '/images/logos/hyUSD.png';
const pumpBTCLogo = '/images/logos/pumpBTC.png';
const solvBTCLogo = '/images/logos/SolvBTC.png';
const solvBTCBNNLogo = '/images/logos/SolvBTCBNN.png';
const lbtcLogo = '/images/logos/LBTC.png';
const ptLBTCLogo = '/images/logos/PTLBTC.png';

type StaticMarketIcons = {
  [Chain in keyof TokenAddressChainValue]: {
    [Symbol in keyof TokenAddressChainValue[Chain]]: string;
  };
};

const StaticMarketIcons: StaticMarketIcons = {
  [ChainIdLegacy.MAINNET]: {
    USDC: usdcLogo,
    WETH: wethLogo,
    APE: apeLogo,
    BAL: balLogo,
    CRV: crvLogo,
    CVX: cvxLogo,
    FRAX: fraxLogo,
    FXS: fxsLogo,
    WBTC: wbtcLogo,
    wstETH: wstethLogo,
    cbETH: cbethLogo,
    LINK: linkLogo,
    BADGER: badgerLogo,
    AURA: auraLogo,
    SUSHI: sushiLogo,
    xSUSHI: xsushiLogo,
    USDT: usdtLogo,
    ENJ: enjLogo,
    PAXG: paxgLogo,
    MIM: mimLogo,
    OHM: ohmLogo,
    WOO: wooLogo,
    ZRX: zrxLogo,
    SHIB: shibLogo,
    GUSD: gusdLogo,
    USDP: usdpLogo,
    CRO: croLogo,
    COMP: compLogo,
    MANA: manaLogo,
    gOHM: gOhmLogo,
    GNO: gnoLogo,
    LUSD: lusdLogo,
    ENS: ensLogo,
    IMX: imxLogo,
    BUSD: busdLogo,
    ONEINCH: oneInchLogo,
    QNT: qntLogo,
    TUSD: tusdLogo,
    YFI: yfiLogo,
    BAT: batLogo,
    UMA: umaLogo,
    sUSD: susdLogo,
    JPEG: jpegLogo,
    BNT: bntLogo,
    LDO: ldoLogo,
    USDD: usddLogo,
    SETH2: sEth2Logo,
    NFTX: nftxLogo,
    DAI: daiLogo,
    BIT: bitLogo,
    SPELL: spellLogo,
    FARM: farmLogo,
    RPL: rplLogo,
    LQTY: lqtyLogo,
    OCEAN: oceanLogo,
    ALCX: alcxLogo,
    DYDX: dydxLogo,
    SAND: sandLogo,
    SNX: snxLogo,
    UNI: uniLogo,
    AAVE: aaveLogo,
    RAI: raiLogo,
    KP3R: kp3rLogo,
    FUN: funLogo,
    FTT: fttLogo,
    PERP: perpLogo,
    WNXM: wNXMLogo,
    MKR: mkrLogo,
    LOOKS: looksLogo,
    AGEUR: agEurLogo,
    RETH: rEthLogo,
    PEPE: pepeLogo,
    XDEFI: xdefiLogo,
    BOX_ETH: boxEthLogo,
    XAI: xaiLogo,
    ETH_stETH: ethStEthLogo,
    FRAX_USDC: fraxUsdcLogo,
    ETH_cbETH: ethCbEthLogo,
    LUSD_3CRV: lusd3CrvLogo,
    stETH_NG: ethStEthLogo,
    crvUSD: crvUSDLogo,
    SILO: siloLogo,
    UWU: uwuLogo,
    weETH: weETHLogo,
    ETHx: ethXLogo,
    PTezETH: ptEzEthLogo,
    sUSDe: sUSDeLogo,
    ezETH: ezEthLogo,
    PTrswETH: PTrswETHLogo,
    rsETH: rsEthLogo,
    PTrsETH: PTrsETHLogo,
    PTweETH: PTeETHLogo,
    PTezETH_DEC2024: ptEzEthLogo,
    PT_ezETH_26SEP2024: ptEzEthLogo,
    PT_weETH_26SEP2024: PTeETHLogo,
    PT_sUSDE_26SEP2024: PT_sUSDE_logo,
    PT_pufETH_26SEP2024: PT_pufETH_logo,
    pzETH: pzETHLogo,
    amphrETH: amphrETHLogo,
    rstETH: rstETHLogo,
    re7LRT: re7LRTLogo,
    PTweETH_DEC2024: PTeETHLogo,
    PTrsETH_DEC2024: PTrsETHLogo,
    PTpufETH_DEC2024: PT_pufETH_logo,
  },
  [ChainIdLegacy.ARBITRUM]: {
    GMD: gmdLogo,
    USDs: usdsLogo,
    DAI: daiLogo,
    GMX: gmxLogo,
    CRV: crvLogo,
    UMAMI: umamiLogo,
    LINK: linkLogo,
    DPX: dpxLogo,
    WBTC: wbtcLogo,
    MAGIC: magicLogo,
    USDT: usdtLogo,
    CAP: capLogo,
    UNI: uniLogo,
    USDC_e: usdcLogo,
    WETH: wethLogo,
    rDPX: rDpxLogo,
    GNS: gnsLogo,
    ARB: arbLogo,
    PREMIA: premiaLogo,
    JONES: jonesLogo,
    OHM: ohmLogo,
    wstETH: wstethLogo,
    SILO: siloLogo,
    rETH: rEthLogo,
    Y2K: y2kLogo,
    JOE: joeLogo,
    PLS: plsLogo,
    GRAIL: grailLogo,
    PENDLE: pendleLogo,
    RDNT: rdntLogo,
    WOO: wooLogo,
    WINR: winrLogo,
    stEUR: stEURLogo,
    LUSD: lusdLogo,
    weETH: weETHLogo,
    PTeETH: PTeETHLogo,
    tBTC: tBtcLogo,
    GRAI: graiLogo,
    PTezETH: ptEzEthLogo,
    ezETH: ezEthLogo,
    PTweETH: PTeETHLogo,
    PTrsETH: PTrsETHLogo,
    WOETH: WOETHLogo,
    PTUSDe: PTUSDeLogo,
    PTezETH_SEPT2024: ptEzEthLogo,
    PTweETH_SEPT2024: PTeETHLogo,
    PTrsETH_SEPT2024: PTrsETHLogo,
    uniETH: uniETHLogo,
    ETHplus: ETHplusLogo,
    PEAS: PEASLogo,
    RAM: RAMLogo,
    wUSDplus: wUSDplusLogo,
    gUSDC: gUSDCLogo,
    ptUSDE_NOV2024: PTUSDeLogo,
    dlcBTC: dlcBTCLogo,
    wUSDM: wUSDMLogo,
    PTweETH_DEC2024: PTeETHLogo,
    PTrsETH_DEC2024: PTrsETHLogo,
    ORDER: orderLogo,
    PTweETH_JUN2025: PTeETHLogo,
    PTrsETH_JUN2025: PTrsETHLogo,
    gmETH: gmETHLogo,
    TANGO: tangoLogo,
  },
  [ChainIdLegacy.OPTIMISM]: {
    WETH: wethLogo,
    USDC: usdcLogo,
    OP: opLogo,
    SNX: snxLogo,
    PENDLE: pendleLogo,
    VELO: veloLogo,
    VELO_V2: veloLogo,
    DAI: daiLogo,
    rETH: rEthLogo,
    sUSD: susdLogo,
    WLD: wldLogo,
    tBTC: tBtcLogo,
    PERP: perpLogo,
    USDT: usdtLogo,
    sfrxETH: sfrxEthLogo,
    wstETH: wstethLogo,
    WBTC: wbtcLogo,
    ezETH: ezEthLogo,
    uniBTC: uniBTCLogo,
    wUSDM: wUSDMLogo,
    SILO: siloLogo,
    mooBIFI: mooBIFILogo,
  },
  [ChainIdLegacy.BASE]: {
    WETH: wethLogo,
    cbETH: cbethLogo,
    wstETH: wstethLogo,
    DEGEN: degenLogo,
    ezETH: ezEthLogo,
    AERO: aeroLogo,
    bsdETH: bsdEthLogo,
    weETH: weETHLogo,
    tBTC: tBtcLogo,
    SILO: siloLogo,
    cbBTC: cbBTCLogo,
    wUSDM: wUSDMLogo,
    wUSDPlus: wUSDplusLogo,
    sUSDz: sUSDzLogo,
    EURC: EURCLogo,
    wSuperOETHb: wSuperOETHbLogo,
    hyUSD: hyUSDLogo,
    pumpBTC: pumpBTCLogo,
    solvBTC: solvBTCLogo,
    solvBTCBNN: solvBTCBNNLogo,
    LBTC: lbtcLogo,
    PT_LBTC_MAY_2025: ptLBTCLogo,
    USDC: usdcLogo,
  },
  [ChainIdLegacy.LOCAL]: {},
  [ChainIdLegacy.ANVIL]: {},
};

const getAddressToLogoMap = () => {
  const entries = Object.entries(StaticMarketIcons);

  return entries.reduce(
    (acc, [key, symbolToLogoMap]) => ({
      ...acc,
      [key]: createMap(Number(key) as SupportedChainId, symbolToLogoMap),
    }),
    {} as SupportedChainValue<Map<ChecksumAddress, string>>
  );
};

const createMap = (chainId: SupportedChainId, symbolToLogoMap: Record<string, string>) => {
  const addressToLogoMap = new Map<ChecksumAddress, string>();
  const symbolToAddressMap = new Map(
    Object.entries(TOKEN_ADDRESS[chainId]).map(([key, value]) => [key.toLowerCase(), value])
  );

  for (const [symbol, logo] of Object.entries(symbolToLogoMap)) {
    const address = symbolToAddressMap.get(symbol.toLowerCase());

    if (address) {
      addressToLogoMap.set(address, logo);
    }
  }

  return addressToLogoMap;
};

const addressToLogoMap = getAddressToLogoMap();

export const resolveTokenLogo = (chainId: ChainIdLegacy | undefined, tokenAddress: ChecksumAddress): string | null =>
  pipe(
    chainId,
    option.fromNullable,
    option.filter(isSupportedChainId),
    option.map((chainId) => addressToLogoMap[chainId].get(tokenAddress)),
    option.chain(option.fromNullable),
    option.getOrElseW(constNull)
  );
